import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { SelectOption } from '../select-option';

export const meta = {
  argTypes: {
    optionOne: { table: { disable: true } },
    optionTwo: { table: { disable: true } },
  },
  args: {
    optionOne: {},
    optionTwo: {},
  },
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Select option/',
};

export const story = ({ optionOne, optionTwo }: Record<string, Partial<SelectOption>>) => html`
  <abds-select name="Select name">
    <abds-select-option
      disabled=${ifDefined(optionOne.disabled || undefined)}
      label=${ifDefined(optionOne.label || undefined)}
      selected=${ifDefined(optionOne.selected || undefined)}
      value=${ifDefined(optionOne.value || undefined)}
    >
      First option
    </abds-select-option>
    <abds-select-option
      disabled="${ifDefined(optionTwo.disabled || undefined)}"
      label="${ifDefined(optionTwo.label || undefined)}"
      selected="${ifDefined(optionTwo.selected || undefined)}"
      value="${ifDefined(optionTwo.value) || undefined}"
    >
      Second option
    </abds-select-option>
  </abds-select>
`;

export default { meta, story };
